/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Subscription_Walkthrough_P3_TitleInputs */

const en_subscription_walkthrough_p3_title = /** @type {(inputs: Subscription_Walkthrough_P3_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<span style="[%1$s]">We’ll remind you<span style="[%2$s]"> 2 days </span>before your trial ends</span>`)
};

const ar_subscription_walkthrough_p3_title = /** @type {(inputs: Subscription_Walkthrough_P3_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<span style="[%1$s]">سنذكرك قبل<span style="[%2$s]">2 أيام </span>قبل انتهاء الفترة التجريبية</span>`)
};

const de_subscription_walkthrough_p3_title = /** @type {(inputs: Subscription_Walkthrough_P3_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<span style="[%1$s]">Wir werden Sie daran erinnern<span style="[%2$s]"> 2 Tage </span>bevor Ihre Probezeit endet</span>`)
};

const es_subscription_walkthrough_p3_title = /** @type {(inputs: Subscription_Walkthrough_P3_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<span style="[%1$s]">Te lo recordaremos<span style="[%2$s]"> 2 días </span> antes de que finalice el periodo de prueba</span>`)
};

const fr_subscription_walkthrough_p3_title = /** @type {(inputs: Subscription_Walkthrough_P3_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<span style="[%1$s]">Nous vous rappelons<span style="[%2$s]"> 2 jours </span>avant la fin de votre essai</span>`)
};

const it_subscription_walkthrough_p3_title = /** @type {(inputs: Subscription_Walkthrough_P3_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<span style="[%1$s]">Te lo ricordiamo<span style="[%2$s]"> 2 giorni </span> prima della fine del periodo di prova</span>`)
};

const ja_subscription_walkthrough_p3_title = /** @type {(inputs: Subscription_Walkthrough_P3_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<span style="[%1$s]">トライアル期間が終了する<span style="[%2$s]">2日前</span>にお知らせします</span>`)
};

const ko_subscription_walkthrough_p3_title = /** @type {(inputs: Subscription_Walkthrough_P3_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<span style="[%1$s]">체험판이 끝나기 <span style="[%2$s]">2일 전</span>에 미리 알려드릴게요</span>`)
};

const pt_br_subscription_walkthrough_p3_title = /** @type {(inputs: Subscription_Walkthrough_P3_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<span style="[%1$s]">Nós enviaremos um lembrete <span style="[%2$s]">2 dias</span> antes do encerramento do período de teste</span>`)
};

const ru_subscription_walkthrough_p3_title = /** @type {(inputs: Subscription_Walkthrough_P3_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<span style="[%1$s]">Мы напомним вам<span style="[%2$s]"> за 2 дня </span>до окончания пробной версии</span>`)
};

const th_subscription_walkthrough_p3_title = /** @type {(inputs: Subscription_Walkthrough_P3_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<span style="[%1$s]">เราจะเตือนคุณ<span style="[%2$s]"> 2 วัน </span>ก่อนการทดลองใช้ของคุณจะสิ้นสุดลง</span>`)
};

const tr_subscription_walkthrough_p3_title = /** @type {(inputs: Subscription_Walkthrough_P3_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<span style="[%1$s]">Deneme süren bitmeden<span style="[%2$s]"> 2 gün önce </span>sana hatırlatacağız</span>`)
};

const zh_cn_subscription_walkthrough_p3_title = /** @type {(inputs: Subscription_Walkthrough_P3_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<span style="[%1$s]">放心，试用结束前<span style="[%2$s]"> 2 天 </span>会提醒你</span>`)
};

const zh_tw_subscription_walkthrough_p3_title = /** @type {(inputs: Subscription_Walkthrough_P3_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<span style="[%1$s]">放心，試用結束前<span style="[%2$s]"> 2 天 </span>會提醒你</span>`)
};

/**
* | output |
* | --- |
* | "<span style=\"[%1$s]\">We’ll remind you<span style=\"[%2$s]\"> 2 days </span>before your trial ends</span>" |
*
* @param {Subscription_Walkthrough_P3_TitleInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const subscription_walkthrough_p3_title = /** @type {((inputs?: Subscription_Walkthrough_P3_TitleInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subscription_Walkthrough_P3_TitleInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_subscription_walkthrough_p3_title(inputs)
	if (locale === "ar") return ar_subscription_walkthrough_p3_title(inputs)
	if (locale === "de") return de_subscription_walkthrough_p3_title(inputs)
	if (locale === "es") return es_subscription_walkthrough_p3_title(inputs)
	if (locale === "fr") return fr_subscription_walkthrough_p3_title(inputs)
	if (locale === "it") return it_subscription_walkthrough_p3_title(inputs)
	if (locale === "ja") return ja_subscription_walkthrough_p3_title(inputs)
	if (locale === "ko") return ko_subscription_walkthrough_p3_title(inputs)
	if (locale === "pt_br") return pt_br_subscription_walkthrough_p3_title(inputs)
	if (locale === "ru") return ru_subscription_walkthrough_p3_title(inputs)
	if (locale === "th") return th_subscription_walkthrough_p3_title(inputs)
	if (locale === "tr") return tr_subscription_walkthrough_p3_title(inputs)
	if (locale === "zh_cn") return zh_cn_subscription_walkthrough_p3_title(inputs)
	return zh_tw_subscription_walkthrough_p3_title(inputs)
});